import { render, staticRenderFns } from "./clinictariff.vue?vue&type=template&id=66e0c70a&"
import script from "./clinictariff.vue?vue&type=script&lang=js&"
export * from "./clinictariff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports